// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"65":"34a7512be629714d","1243":"7661d0bec8489f0e","3737":"0010e9800a4dc138","4374":"6c019a08a7c7d14c","5262":"852b03879f5dcab6"}[chunkId] + ".js";
};